import React, { memo, useCallback } from "react";
import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";
import Icon from "../Icons/Icon";
import "./HawkeyeSearchMenu.scss";

function HawkeyeSearchSubPages(props) {
  const { pages, onSubPageSelection, depth, selectedSubPageIndex } = props;

  return (
    <div>
      {pages.map((p, i) => (
        <div key={`hawkeye_search_menu_parent_${p.page}_${i}`}>
          <div
            className={`hawkeye-subpage-container ${
              selectedSubPageIndex[depth] == i && "is-selected"
            }`}
            onClick={() => onSubPageSelection(i, depth)}
            key={`hawkeye_search_menu_${i}`}
          >
            <div>
              <a key={p.page} className={`hawkeye-search-page `}>
                {AxiomAPIs.translate(p.page)}
              </a>
            </div>
            {p.subpages && p.subpages.length > 0 && (
              <div className="hawkeye-subpage-arrow-icon-container">
                <Icon
                  icon={selectedSubPageIndex[depth] == i ? "ICON_ARROW_UP" : "ICON_ARROW_DOWN"}
                  className={`hawkeye-icon-subpage-arrow ${
                    selectedSubPageIndex[depth] == i && "is-selected"
                  }`}
                />
              </div>
            )}
          </div>
          {p.subpages && p.subpages.length > 0 && selectedSubPageIndex[depth] == i && (
            <HawkeyeSearchSubPages
              pages={p.subpages}
              onSubPageSelection={onSubPageSelection}
              depth={depth + 1}
              selectedSubPageIndex={selectedSubPageIndex}
            />
          )}
        </div>
      ))}
    </div>
  );
}

export default memo(HawkeyeSearchSubPages);
